import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faBlockQuote } from '@fortawesome/pro-light-svg-icons';

export type ProLightBlockQuoteProps = IconComponentProps;

export const ProLightBlockQuote = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightBlockQuoteProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faBlockQuote}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faBlockQuote}
    />
  );
};

ProLightBlockQuote.displayName = 'ProLightBlockQuote';
